import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { PrimaryButton } from 'src/components/ui/Buttons';
import { dividerColor } from 'src/data/colors';
import { Equipment } from 'src/models';
import { PathBuilder } from 'src/routing';
import { borderRadius } from 'src/data/borders';

const useStyles = makeStyles({
  table: {
    width: '100%',
    display: 'block',
    minWidth: 650,
    border: `1px solid ${dividerColor}`,
    borderRadius: borderRadius.md,
    overflowX: 'auto',
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto',
    border: `1px solid ${dividerColor}`,
    borderRadius: borderRadius.md,
  },
  tableComponent: {
    minWidth: 650,
  },
  header: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  container: {
    width: '100%',
    maxWidth: '100%',
    marginTop: 48,
  },
  lastRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
  tableHeader: {
    textTransform: 'uppercase',
    fontSize: 12,
  },
});

const getEquipmentStatus = (equipment: Equipment) => {
  if (equipment.isConnected) {
    return 'Connected';
  } else if (equipment.isConnected === false) {
    return 'Disconnected';
  } else {
    return (
      <Tooltip title="No status has been reported by the equipment">
        <span>Unknown</span>
      </Tooltip>
    );
  }
};

interface EquipmentListProps {
  equipmentList: Equipment[];
  siteId: number;
}

const EquipmentList = ({ equipmentList, siteId }: EquipmentListProps) => {
  const classes = useStyles();
  const showStatusColumn = equipmentList.some((equipment) => equipment.isConnected !== undefined);
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography>Equipment List</Typography>
        <PrimaryButton component={Link} to={PathBuilder.EQUIPMENT(siteId)}>
          Go to Equipment
        </PrimaryButton>
      </div>
      <TableContainer className={classes.tableContainer}>
        <Table className={classes.tableComponent} aria-label="simple table">
          <TableHead>
            <TableRow className={classes.tableHeader}>
              <TableCell>Make</TableCell>
              <TableCell align="left">Model</TableCell>
              {showStatusColumn ? <TableCell align="left">Status</TableCell> : null}
              <TableCell align="left">Serial number</TableCell>
              <TableCell align="left">Firmware version</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {equipmentList.map((row, index) => {
              // check if this is correct
              if (!row.make) return null;
              return (
                <TableRow
                  key={row.id}
                  className={index === equipmentList.length - 1 ? classes.lastRow : ''}
                >
                  <TableCell align="left">{row.make}</TableCell>
                  <TableCell align="left">{row.model}</TableCell>
                  {showStatusColumn ? (
                    <TableCell align="left">{getEquipmentStatus(row)}</TableCell>
                  ) : null}
                  <TableCell align="left">{row.serialNumber}</TableCell>
                  <TableCell align="left">{row.firmwareVersion || ' - '}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default EquipmentList;
